'use client'

// import Banner from '@/public/images/inner-banner.png'
// import Image from 'next/image'
import { 
  AuthenticatedTemplate,
  UnauthenticatedTemplate, 
  useMsal,
  // IMsalContext
} from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser"
import { loginRequest } from 'AuthConfig'
import { useLanguage } from 'contexts/LanguageContext'
import { useState, useEffect, FormEvent } from 'react';
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import TelemetryIntitializer from "services/TelemetryIntitializer";
import { ServiceCoursesProvider } from 'api/ServiceCoursesProvider';
import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { MessageBar, MessageBarType } from "@fluentui/react/lib/MessageBar";
import Spinner from 'components/spinner';
import { useSubscription } from 'contexts/SubscriptionContext';

const dropdownStyles: Partial<IDropdownStyles> = { 
  dropdown: { 
    width: 270, 
    borderWidth: "0 0 1px 0", 
    borderColor: "#707070", 
    fontFamily: "'Inter', sans-serif", 
    fontSize: "1rem",
    color: "#000000",
    padding: "0.75rem 0" 
  }, 
  title: { border: 0, color: "#707070" },
  caretDownWrapper: { top: "0.75rem"}
};

const dropdownOptions: IDropdownOption[] = [];
let firstSubscriberDropdownOptions: IDropdownOption[] = [];
let languagesOptions: IDropdownOption[] = [];
const additionalSubscribersToSend: any[] = [];

export default function Subscribe() {
  const { 
    lang, 
    res 
  } = useLanguage();
  const { instance, accounts } = useMsal();
  const msal = useMsal()
  const [dirty, setDirty] = useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [organisationName, setOrganisationName] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [position, setPosition] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [numberAndStreet, setNumberAndStreet] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [province, setProvince] = useState<string>("");
  const [postalCode, setPostalCode] = useState<string>("");
  const [subscriberFirstName1, setSubscriberFirstName1] = useState<string>("");
  const [subscriberLastName1, setSubscriberLastName1] = useState<string>("");
  const [subscriberEmail1, setSubscriberEmail1] = useState<string>("");
  const [selectedType, setSelectedType] = useState<IDropdownOption>();
  const [selectedLanguage, setSelectedLanguage] = useState<IDropdownOption>();
  const [additionalSubscribers, setAdditionalSubscribers] = useState<any[]>([]);
  const [fsDropdownOptions, setFsDropdownOptions] = useState<IDropdownOption[]>([]);
  // const [codePromo, setCodePromo] = useState<string>("");
  const { subscription } = useSubscription();
  const [loading, setLoading] = useState(false);
  const [firstSubscriberBuyer, setFirstSubscriberBuyer] = useState<boolean>(true);
  const [accepteCondition, setAccepteCondition] = useState<boolean>(false);
  const [errors, setErrors] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [sending, setSending] = useState<boolean>(false);
  const [pageError, setPageError] = useState<string | null>(null);

  const onChangeType = (_event: FormEvent<HTMLDivElement>, item: IDropdownOption | undefined): void => {
    setSelectedType(item);
    setDirty(false);
  };

  const onChangeLanguage = (_event: FormEvent<HTMLDivElement>, item: IDropdownOption | undefined): void => {
    setSelectedLanguage(item);
    setDirty(false);
  }

  useEffect(() => {
    setLoading(true);
    languagesOptions = [];
    languagesOptions.push(
      {
        key: "fr",
        text: res["Français"]
      },
      {
        key: "en",
        text: res["Anglais"]
      }
    );
    setSelectedLanguage({
      key: lang,
      text: (lang === "fr") ? res["Français"] : res["Anglais"]
    });
    getSubscription();
  }, [lang, subscription]);

  async function getTypesSubscription() {
    try {
      const typesSubscription = await ServiceCoursesProvider.provider.getTypesSubscription(msal, lang);
      if (typesSubscription && typesSubscription.typesAbonnements) {
        const typesAbonnement = _copyAndSort(typesSubscription.typesAbonnements, "ordre");
        
        // Clear and rebuild dropdown options
        dropdownOptions.length = 0;
        dropdownOptions.push({
          key: "",
          text: res["Sélectionnez un type d'abonnement"] || "Sélectionnez un type d'abonnement"
        });
        
        typesAbonnement.forEach((tSubscr: any) => {
          dropdownOptions.push({
            key: tSubscr.id,
            text: tSubscr.titre[lang]
          });
        });
        const subscriptionId = subscription?.abonnement?.id;
        firstSubscriberDropdownOptions = [];
        if (subscriptionId && subscriptionId !== "undefined") {
          let getTypeToSelect: IDropdownOption[] = dropdownOptions.filter((typeOpt) => typeOpt.key === subscriptionId);
          const currentType: any[] = typesAbonnement.filter((tA: any) => tA.id === subscriptionId);
          if (getTypeToSelect && getTypeToSelect.length > 0) {
            let addedOptions = 0;
            firstSubscriberDropdownOptions.push({
              key: "",
              text: res["Sélectionnez un type d'abonnement"] || "Sélectionnez un type d'abonnement"
            });
            typesAbonnement.forEach((tA: any) => {
              if (currentType[0] && tA.ordre > currentType[0].ordre) {
                addedOptions++;
                firstSubscriberDropdownOptions.push({
                  key: tA.id,
                  text: tA.titre[lang]
                });
                if (addedOptions === 1) {
                  getTypeToSelect = [{
                    key: tA.id,
                    text: tA.titre[lang]
                  }];
                }
              }
            });
            setSelectedType(getTypeToSelect[0]);
            setFsDropdownOptions(firstSubscriberDropdownOptions);
          }
        } else {
          firstSubscriberDropdownOptions = [];
          firstSubscriberDropdownOptions.push({
            key: "",
            text: res["Sélectionnez un type d'abonnement"] || "Sélectionnez un type d'abonnement"
          });
          typesAbonnement.forEach((tSubscr: any) => {
            firstSubscriberDropdownOptions.push({
              key: tSubscr.id,
              text: tSubscr.titre[lang]
            });
          });
          setFsDropdownOptions(firstSubscriberDropdownOptions);
        }
      }
    } catch (error) {
      setPageError(error?.toString() ?? null);
    }
  }

  async function getSubscription() {
    if (subscription) {
      /* console.log("accounts: ", accounts);
      let currentSubscription = await ServiceCoursesProvider.provider.getSubscriptions(msal);
      if (!currentSubscription || currentSubscription.length === 0 || !currentSubscription.abonnement) {
        // no subscription found
        // call the API to create a new subscription
        console.log("call the API to create a new subscription");
        currentSubscription = await ServiceCoursesProvider.provider.createSubscription(msal);
        if (currentSubscription) {
          setSubscription(currentSubscription);
        }
      } else {
        setSubscription(currentSubscription);
      } */
      const currentSubscription = subscription;
      const orgName: string = (currentSubscription?.nomOrganisation) ? currentSubscription?.nomOrganisation : (accounts[0] && accounts[0].idTokenClaims) ? accounts[0].idTokenClaims.name ?? "" : "";
      const firstName: string = (currentSubscription?.prenom) ? currentSubscription?.prenom : (accounts[0] && accounts[0].idTokenClaims) ? accounts[0].idTokenClaims.given_name as string ?? "" : "";
      const lastName: string = (currentSubscription?.nom) ? currentSubscription?.nom : (accounts[0] && accounts[0].idTokenClaims) ? accounts[0].idTokenClaims.family_name as string ?? "" : "";
      const emailAddress: string = (currentSubscription?.emailAdress) ? currentSubscription?.emailAdress : (accounts[0] && accounts[0].idTokenClaims) ? accounts[0].idTokenClaims.email as string ?? "" : "";
      console.log("currentSubscription: ", currentSubscription);
      setOrganisationName(orgName);
      setFirstName(firstName);
      setSubscriberFirstName1(firstName);
      setLastName(lastName);
      setSubscriberLastName1(lastName);
      setEmail(emailAddress);
      setSubscriberEmail1(emailAddress);
      if (currentSubscription?.langue) {
        const languageToSet = languagesOptions.filter((opt) => opt.key === currentSubscription?.langue);
        if (languageToSet && languageToSet.length > 0) {
          setSelectedLanguage(languageToSet[0]);
        }
      }
      getTypesSubscription();
      setLoading(false);
    }
  }

  function _copyAndSort<T>(items: T[], columnKey1: string, isSortedDescending?: boolean): T[] {
    const key1 = columnKey1 as keyof T;
    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key1] < b[key1] : a[key1] > b[key1]) ? 1 : -1));
  }

  function UserAuthenticated() {
    return (
      <>
      <section>
        {/* <Image src={Banner} priority={true} alt="Talamus" className="w-full" /> */}
        <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
  
          <div className="relative pt-32 _pb-10 _md:pb-16">
  
            <div className="_max-w-3xl mx-auto _text-center _pb-12 _md:pb-16">
              <h1 className="h1 mb-8" data-aos="fade-up">{res["Formulaire d'inscription"]}</h1>
              <div className="grid md:grid-cols-12 gap-8 _lg:gap-20 mb-8 md:mb-12">
                  {/* 1st block */}
                  <div className="md:col-span-4 lg:col-span-4 c-content-area min-w-[220px]">
                      <h4>{res["Abonnement Découverte"]}</h4>
                      <ul>
                        {res["AbonnementDecouvertePointsArray"] && res["AbonnementDecouvertePointsArray"].map((point: string, idx: number) => (
                          <li key={idx}>{point}</li>
                        ))}
                      </ul>
                  </div>
                  <div className="md:col-span-4 lg:col-span-4 c-content-area blw-1 lg:pl-4 min-w-[220px]">
                      <h4>{res["Abonnement Efficace"]}</h4>
                      <ul>
                          {res["AbonnementEfficacePointsArray"] && res["AbonnementEfficacePointsArray"].map((key: string, idx: number) => (
                            <li key={idx}>{key}</li>
                          ))}
                      </ul>
                  </div>
                  <div className="md:col-span-4 lg:col-span-4 c-content-area blw-1 lg:pl-4 min-w-[265px]">
                      <h4>{res["Abonnement Premium"]}</h4>
                      <ul>
                        {res["AbonnementPremiumPointsArray"] && res["AbonnementPremiumPointsArray"].map((key: string, idx: number) => (
                          <li key={idx}>{key}</li>
                        ))}
                      </ul>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="c-condition-sec">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
              <h2>{res["Conditions"]}</h2>
              <div className="grid md:grid-cols-12 gap-8 mb-8 md:mb-12">
                  <div className="md:col-span-6 lg:col-span-6 c-content-area">
                      <h4>{res["Abonnement Découverte"]}</h4>
                      <ul>
                          <li>{res["Les abonnements sont attribués à des individus(es) et ne peuvent être partagés."]}</li>
                          <li>{res["Les abonnements ne sont pas transférables dans le temps."]}</li>
                          <li>{res["L'abonnement Découverte est libre de tout engagement et sans frais."]}</li>
                      </ul>
                  </div>
                  <div className="md:col-span-6 lg:col-span-6 c-content-area lg:pl-12 borderB">
                      <h4>{res["Abonnement Efficace et Champion"]}</h4>
                      <ul>
                          <li>{res["Les abonnements sont attribués à des individus(es) et ne peuvent être partagés."]}</li>
                          <li>{res["Les abonnements ne sont pas transférables dans le temps."]}</li>
                          <li>{res["Les abonnements ne sont pas remboursables, à l'exception qu'une demande soit acheminée."]}</li>
                          <li>{res["En complétant et en envoyant le formulaire, les abonnements seront activés dans les 5 prochaines heures"]}</li>
                          <li>{res["Une facture payable dans les 30 jours sera envoyée par courriel dans les 24 prochaines heures suivant l'envoi du formulaire d'inscription."]}</li>
                      </ul>
                  </div>
              </div>
          </div>
      </section>
      <section className="bg-white">
        <div id="buyerFormWrap" className="max-w-7xl mx-auto px-4 sm:px-6 relative">
          <div className="relative pt-32 pb-10 md:pb-16">
          {(sent) ? (
          <MessageBar messageBarType={MessageBarType.success} styles={{root: {marginTop: "10px"}}}>
            {res["Merci d'avoir soumis votre demande."]}
          </MessageBar>) : 
          (
            <div className="form-wrap mx-auto">
              <h2>{res["INFORMATIONS ACHETEUR"]}</h2>
              {pageError && pageError.trim() !== "" && (
                <div className="bg-red-600 text-white p-3 mb-4 rounded">
                  {res['Erreur generique']}
                </div>
              )}
              {(loading) ? (
                <Spinner />
              ) : (
              <form className="w-full" id="buyerForm" onSubmit={(ev) => onSubmitForm(ev)}>
                <label htmlFor="nomOrganisation">{res["Nom de votre organisation"]} <span className="text-red-600">*</span></label>
                <div className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <input type="text" name="nomOrganisation" id="nomOrganisation"
                    value={organisationName}
                    onChange={(ev) => {setOrganisationName((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Entreprise"]} 
                    aria-label={res["Entreprise"]} 
                  />
                </div>
                {(dirty && !organisationName) ? (
                  <div>
                    <span id="nomOrganisationMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                  </div>
                ) : null}
                <label>{res["Personne ressource"]} <span className="text-red-600">*</span></label>
                <div className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <input type="text" name="prenom" id="prenom"
                    value={firstName}
                    onChange={(ev) => {setFirstName((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Prénom"]}
                    aria-label={res["Prénom"]}
                  />
                  <input type="text" name="nom" id="nom" 
                    value={lastName}
                    onChange={(ev) => {setLastName((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Nom"]}
                    aria-label={res["Nom"]}
                  />
                  <input type="text" name="fonction" id="fonction" 
                    value={position}
                    onChange={(ev) => {setPosition((ev as any)?.target?.value);}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Fonction"]}
                    aria-label={res["Fonction"]}
                  />
                  <input type="text" name="courriel" id="courriel" 
                    value={email}
                    onChange={(ev) => {setEmail((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Courriel"]}
                    aria-label={res["Courriel"]}
                  />
                </div>
                <div className="flex flex-col sm:flex-row justify-center max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <div className="w-full">
                    {(dirty && !firstName) ? (
                      <span id="prenomMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                    {(dirty && !lastName) ? (
                      <span id="nomMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                  {(dirty && !position) ? (
                      <span id="fonctionMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                  {(dirty && !email) ? (
                      <span id="courrielMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                </div>
                <label>{res["Adresse"]} <span className="text-red-600">*</span></label>
                <div className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <input type="text" name="numeroEtRue" 
                    value={numberAndStreet}
                    onChange={(ev) => {setNumberAndStreet((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Numéro et rue"]} 
                    aria-label={res["Numéro et rue"]} 
                  />
                </div>
                <div>
                  {(dirty && !numberAndStreet) ? (
                      <span id="numeroEtRueMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                </div>
                <div className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <input type="text" name="ville" 
                    value={city}
                    onChange={(ev) => {setCity((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Ville"]} 
                    aria-label={res["Ville"]} 
                  />
                  <input type="text" name="province" 
                    value={province}
                    onChange={(ev) => {setProvince((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Province"]} 
                    aria-label={res["Province"]} 
                  />
                  <input type="text" name="codePostal" 
                    value={postalCode}
                    onChange={(ev) => {setPostalCode((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Code postal"]} 
                    aria-label={res["Code postal"]} 
                  />
                </div>
                <div className="flex flex-col sm:flex-row justify-center max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <div className="w-full">
                  {(dirty && !city) ? (
                      <span id="villeMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                  {(dirty && !province) ? (
                      <span id="provinceMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                  {(dirty && !postalCode) ? (
                      <span id="codePostalMessage" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <div className="subscriberLabel">{res["ABONNÉ(S)"]}</div>
                  <button 
                    className="btn-sm text-gray-700 bg-orange hover:bg-orange mr-4"
                    onClick={(ev) => addRemoveSubscribers(ev, true)}
                  >
                    {res["Ajouter"]}
                  </button>
                  <button 
                    className="btn-sm text-gray-700 bg-orange hover:bg-orange"
                    disabled={additionalSubscribersToSend.length === 0}
                    onClick={(ev) => addRemoveSubscribers(ev, false)}
                  >
                    {res["Retirer"]}
                  </button>
                  <div style={{width: "90%"}}>&nbsp;</div>
                </div>
                <div className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <div className="subscriberLabel w-full">{res["Abonné"]} #1 :&nbsp;<span className="text-red-600">*</span>&nbsp;&nbsp;
                    <input type="checkbox" name="firstSubscriberBuyer" 
                      className="relative mr-1"
                      style={{top: "1px"}}
                      checked={firstSubscriberBuyer}
                      onChange={(ev) => {setBuyerOrNot(ev)}}
                    />
                    {res["Acheteur"]}
                  </div>
                  <input type="text" name="prenomAbonne1" id="prenomAbonne1"
                    value={subscriberFirstName1}
                    disabled={firstSubscriberBuyer}
                    onChange={(ev) => {setSubscriberFirstName1((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Prénom"]}
                    aria-label={res["Prénom"]}
                  />
                  <input type="text" name="nomAbonne1" id="nomAbonne1"
                    value={subscriberLastName1}
                    disabled={firstSubscriberBuyer}
                    onChange={(ev) => {setSubscriberLastName1((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    placeholder={res["Nom"]}
                    aria-label={res["Nom"]}
                  />
                  <input type="text" name="courrielAbonne1" id="courrielAbonne1"
                    value={subscriberEmail1}
                    onChange={(ev) => {setSubscriberEmail1((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                    disabled={firstSubscriberBuyer}
                    placeholder={res["Courriel"]}
                    aria-label={res["Courriel"]}
                  />
                  <Dropdown
                    selectedKey={selectedType ? selectedType.key : ""}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={onChangeType}
                    options={firstSubscriberBuyer ? fsDropdownOptions : dropdownOptions}
                    styles={dropdownStyles}
                  />
                  <Dropdown 
                    options={languagesOptions}
                    selectedKey={selectedLanguage ? selectedLanguage.key : undefined}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={onChangeLanguage}
                    styles={dropdownStyles}
                    style={{width: "120px", marginLeft: "10px"}}
                  />
                </div>
                <div className="flex flex-col sm:flex-row justify-center max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <div className="w-full"></div>
                  <div className="w-full">
                    {(dirty && !subscriberFirstName1) ? (
                      <span id="prenomAbonne1Message" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                    {(dirty && !subscriberLastName1) ? (
                      <span id="nomAbonne1Message" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                    {(dirty && !subscriberEmail1) ? (
                      <span id="courrielAbonne1Message" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                  <div className="w-full">
                    {(dirty && (!selectedType?.key || selectedType.key === "")) ? (
                      <span id="typeAbonne1Message" className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                    ) : null}
                  </div>
                </div>
                {(additionalSubscribers.length > 0) ? (
                  <div key="additionalSubscribers">
                      {additionalSubscribers.map((sbscr, sIndex) => (
                        <div key={"additionalSubscribersBloc"+sIndex}>
                          <div key={"additionalSubscriber"+sIndex} className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                            <div className="subscriberLabel w-full">{res["Abonné"]} #{sIndex+2} :&nbsp;<span className="text-red-600">*</span></div>
                            <input type="text" name={"prenomAbonne"+(sIndex+2)} id={"prenomAbonne"+(sIndex+2)} 
                              value={sbscr.prenom}
                              onChange={(ev) => editAdditionalSubscriber("prenom", (ev as any)?.target?.value, sIndex)}
                              onFocus={() => {setDirty(false)}}
                              className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                              placeholder={res["Prénom"]}
                              aria-label={res["Prénom"]}
                            />
                            <input type="text" name={"nomAbonne"+(sIndex+2)} id={"nomAbonne"+(sIndex+2)}
                              value={sbscr.nom}
                              onChange={(ev) => editAdditionalSubscriber("nom", (ev as any)?.target?.value, sIndex)}
                              onFocus={() => {setDirty(false)}}
                              className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                              placeholder={res["Nom"]}
                              aria-label={res["Nom"]}
                            />
                            <input type="text" name={"courrielAbonne"+(sIndex+2)} id={"courrielAbonne"+(sIndex+2)}
                              value={sbscr.courriel}
                              onChange={(ev) => editAdditionalSubscriber("courriel", (ev as any)?.target?.value, sIndex)}
                              onFocus={() => {setDirty(false)}}
                              className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                              placeholder={res["Courriel"]}
                              aria-label={res["Courriel"]}
                            />
                            <Dropdown id={"typeAbonne"+(sIndex+2)}
                              selectedKey={(sbscr && sbscr.type) ? sbscr.type.key : ""}
                              // eslint-disable-next-line react/jsx-no-bind
                              onChange={(_ev: any, item: any) => editAdditionalSubscriber("type", item, sIndex)}
                              options={dropdownOptions}
                              styles={dropdownStyles}
                            />
                            <Dropdown id={"langue"+(sIndex+2)} 
                              options={languagesOptions}
                              selectedKey={(sbscr && sbscr.langue) ? sbscr.langue.key : undefined}
                              // eslint-disable-next-line react/jsx-no-bind
                              onChange={(_ev: any, item: any) => editAdditionalSubscriber("langue", item, sIndex)}
                              styles={dropdownStyles}
                              style={{width: "120px", marginLeft: "10px"}}
                            />
                          </div>
                          <div key={"additionalSubscriberMessages"+sIndex} className="flex flex-col sm:flex-row justify-center max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                            <div className="w-full"></div>
                            <div className="w-full">
                              {(dirty && !sbscr.prenom) ? (
                                <span id={"prenomAbonne"+(sIndex+2)+"Message"} className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                              ) : null}
                            </div>
                            <div className="w-full">
                              {(dirty && !sbscr.nom) ? (
                                <span id={"nomAbonne"+(sIndex+2)+"Message"} className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                              ) : null}
                            </div>
                            <div className="w-full">
                              {(dirty && !sbscr.courriel) ? (
                                <span id={"courrielAbonne"+(sIndex+2)+"Message"} className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                              ) : null}
                            </div>
                            <div className="w-full">
                            {(dirty && (!sbscr.type?.key || sbscr.type.key === "")) ? (
                                <span id={"typeAbonne"+(sIndex+2)+"Message"} className="errorMessage relative rounded-sm text-red-600 topM30">{res["Veuillez remplir ce champ"]}</span>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  ) : null}
                <div className="flex flex-col sm:flex-row justify-center pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                {/* <div className="subscriberLabel" style={{minWidth: "260px"}}>{res["Avez-vous un code promotionnel :"]}</div>
                  <input type="text" name="codePromo" 
                    value={codePromo}
                    onChange={(ev) => {setCodePromo((ev as any)?.target?.value)}}
                    onFocus={() => {setDirty(false)}}
                    className="w-full rounded-sm px-0 py-3 mb-2 sm:mb-0 sm:mr-2" 
                  />
                  <button 
                    className="btn-sm text-gray-700 bg-orange hover:bg-orange mr-4"
                    onClick={(ev) => validatePromoCode(ev)}
                  >
                    {res["Valider"]}
                  </button> */}
                </div>
                  
                <div className="flex flex-col sm:flex-row justify-start text-black pb-4 max-w-xs mx-auto sm:max-w-md lg:max-w-none">
                  <input type="checkbox" name="accepteCondition" 
                    className="relative mr-1"
                    style={{top: "3px"}}
                    onChange={(ev) => {setAccepteCondition(!!ev?.target?.checked)}}
                  />
                  {res["En cochant cette case, j'affirme avoir pris connaissance et accepte les conditions générales de l'abonnement et son coût."]} 
                  {(dirty && !accepteCondition) ? (
                      <span id="accepteConditionMessage" className="errorMessage absolute rounded-sm text-red-600">{res["Veuillez cocher cette case si vous souhaitez continuer"]}</span>
                    ) : null}
                </div>
                <button disabled={sending} onClick={(ev) => onSubmitForm(ev)} className="btn-sm text-gray-700 bg-orange hover:bg-orange mt-4">
                  {res["S'ABONNER"]}
                </button>
                {(errorMessage) ? (
                  <MessageBar messageBarType={MessageBarType.error} styles={{root: {marginTop: "10px"}}}>{errorMessage}</MessageBar>
                ) : null}
              </form>
              )}
            </div>
            )}
          </div>
        </div>
      </section>
      </>
    )
  }

  const setBuyerOrNot = (e: any) => {
    const isChecked = !!e?.target?.checked;
    setFirstSubscriberBuyer(isChecked);
    if (isChecked) {
      setSubscriberFirstName1(firstName);
      setSubscriberLastName1(lastName);
      setSubscriberEmail1(email);
    }
    else      
    {
      setSelectedType({key: "", text: ""});
      setSubscriberFirstName1("");
      setSubscriberLastName1("");
      setSubscriberEmail1("");
    }
      
  }

  const addRemoveSubscribers = (e: FormEvent, add = true) => {
    e.preventDefault();
    if (add) {
      additionalSubscribersToSend.push(
        {
          prenom: "",
          nom: "",
          courriel: "",
          type: {key: "", text: ""},
          langue: {...selectedLanguage}
        }
      );
      setDirty(false);
    } else {
      additionalSubscribersToSend.pop();
    }
    
    // set the state array for the subscribers
    setAdditionalSubscribers(additionalSubscribersToSend.slice());
  }

  const editAdditionalSubscriber = (fieldName: string, value: string | IDropdownOption | undefined, sIndex: number) => {
    additionalSubscribersToSend[sIndex][fieldName] = value;
    setAdditionalSubscribers(additionalSubscribersToSend.slice());
  }

  // const validatePromoCode = (e: FormEvent) => {
  //   e.preventDefault();
  // }

  const onSubmitForm = async (e: FormEvent) => {
    e.preventDefault();
    setDirty(true);
    let insights: ApplicationInsights | null = TelemetryIntitializer.getAppInsights();
    const subscribers: any[] = [
      {
        prenom: subscriberFirstName1,
        nom: subscriberLastName1,
        courriel: subscriberEmail1,
        typeAbonnementId: selectedType?.key,
        langue: selectedLanguage?.key
      }
    ];
    if (additionalSubscribers.length > 0) {
      additionalSubscribers.forEach((sbscr) => {
        subscribers.push({
          prenom: sbscr.prenom,
          nom: sbscr.nom,
          courriel: sbscr.courriel,
          typeAbonnementId: sbscr.type?.key,
          langue: sbscr.langue?.key
        });
      });
    }
    let errN = 0;
    if (organisationName === "") {
      errN++;
    }
    if (firstName === "") {
      errN++;
    }
    if (lastName === "") {
      errN++;
    }
    if (position === "") {
      errN++;
    }
    if (email === "") {
      errN++;
    }
    if (numberAndStreet === "") {
      errN++;
    }
    if (city === "") {
      errN++;
    }
    if (province === "") {
      errN++;
    }
    if (postalCode === "") {
      errN++;
    }
    subscribers.forEach((sbscr) => {
      if (sbscr) {
        if (sbscr.prenom === "") {
          errN++;
        }
        if (sbscr.nom === "") {
          errN++;
        }
        if (sbscr.courriel === "") {
          errN++;
        }
        if (sbscr.typeAbonnementId === "" || sbscr.typeAbonnementId === undefined) {
          errN++;
        }
      }
    });
    if (!accepteCondition) {
      errN++;
    }
    let formToSend = {
      nomOrganisation: organisationName,
      prenom: firstName,
      nom: lastName,
      fonction: position,
      courriel: email,
      numeroEtRue: numberAndStreet,
      ville: city,
      province: province,
      codePostal: postalCode,
      abonnes: subscribers,
      // CodePromo: codePromo,
      typeAbonnementId: (subscription?.abonnement?.id)
    };
    console.log("formToSend: ", formToSend, " accepteCondition: ", accepteCondition, " errN: ", errN);
    setErrors(errN);
    if (errN === 0) {
      // if no errors send the form 
      setSending(true);
      try {
        const nSbscr = await ServiceCoursesProvider.provider.sendSubscription(msal, lang, formToSend);
        if (insights) {
          insights.trackEvent(subscription as any, {formToSend: formToSend});
        }
        setSending(false);
        if (nSbscr && nSbscr.error) {
          setErrorMessage(nSbscr.error);
        } else {
          setSent(true);
        }
        console.log("nSbscr: ", nSbscr);
      } catch (error) {
        setSending(false);
        setPageError(error?.toString() ?? null);
      }
    }
  }

  function signInClickHandler(instance: IPublicClientApplication) {
    // Open B2C login with a redirect 
    loginRequest.extraQueryParameters = {
      ui_locales: lang === 'fr' ? "fr-ca" : 'en-ca' // Change this to the desired locale
    };
    instance.loginRedirect(loginRequest)
    // another method could open that with a popup window 
    // instance.loginPopup(loginRequest)
  }
  
  return (
    <>
    <AuthenticatedTemplate>
      {/* The form will only render if a user is signed-in */}
      {/* <UserAuthenticated /> */}
      {UserAuthenticated()}
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
      <section>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
          <div className="relative pt-32 pb-10 md:pb-16">
            <div className="messageWrap">
              {res["Connectez-vous pour accéder au formulaire d'abonnement"]}
              <button onClick={() => signInClickHandler(instance)} className="btn-sm text-white bg-gray-700 hover:bg-gray-800 ml-3">
                {res["Me connecter"]}
              </button>
            </div>
          </div>
        </div>
      </section>
    </UnauthenticatedTemplate>
    </>
  )
}
